








import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import TranslationSource from '@/types/i18n/TranslationSource';
import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({
  components: {
    NewTranslation,
    Button,
  },
})
export default class BookingProceedButton extends Vue {
  @Prop(Number)
  public totalPrice!: number;

  @Prop(Boolean)
  public disabled!: boolean;

  @Emit()
  public click(): void {}
}
